module.exports = __webpack_public_path__ + "src/img/artist/name04.svg?1ac68d795abaafb0e1c92f7da3a0cb81";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name04.svg
// module id = 140
// module chunks = 0